/* eslint-disable import/prefer-default-export */

import styled from 'styled-components';
import Alert from '../Alert';
export const StyledAlert = styled(Alert).attrs({
  className: 'section--sm'
})`
  align-items: center;
`;
//# sourceMappingURL=styles.js.map